export const ScoringBaseURL = `https://scoringapi.codechallenge-championship.org`;
export const BaseURL = `https://api.codechallenge-championship.org`;
// export const BaseURL = `https://apistaging.codechallenge-championship.org`;

export const applicationURL = `${BaseURL}/competetions/1/applications`;
export const categoriesURL = `${BaseURL}/competetions/1/categories`;
export const firstStageURL = `${BaseURL}/registeration`;
export const countriesURL = `${BaseURL}/registeration/countries`;
export const organizationsURL = `${BaseURL}/registeration/organizations`;
export const paymentURL = `${BaseURL}/payment`;
export const categoriesScoringURL = `${ScoringBaseURL}/website/ranking/categories`;
export const rankingURL = `${ScoringBaseURL}/website/ranking`;
export const reportURL = `${ScoringBaseURL}/website/ranking`;
